var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHearing2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 300,
    viewBox: "0 0 301 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.341 300C233.029 300 300.052 232.948 300.052 150.289C300.052 67.6302 233 0.578125 150.341 0.578125C67.6819 0.578125 0.629883 67.6302 0.629883 150.289C0.629883 232.948 67.653 300 150.341 300Z",
    fill: "#E3147D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.59,
    d: "M143.983 38.1501L77.2196 68.2079L1.20801 160.116C4.21379 216.763 42.8265 273.988 104.098 291.618L149.185 250.289L159.3 196.821L216.526 160.116L228.087 130.058L221.439 71.4334L158.722 38.1501H143.983Z",
    fill: "url(#paint0_linear)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.421 95.1959C235.338 78.522 223.11 64.2761 207.059 53.9986C192.587 44.7322 175.903 39.3139 158.433 38.1503V57.9512C197.178 61.2781 227.607 91.328 227.607 127.791C227.607 128.935 227.576 130.076 227.527 131.214C232.11 129.058 236.113 125.866 239.108 121.837C244.937 113.995 246.176 104.036 242.421 95.1959Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.064 166.474H80.9609C65.3268 166.474 52.6528 154.634 52.6528 140.029V131.214H121.064C131.487 131.214 139.936 139.107 139.936 148.844C139.936 158.581 131.487 166.474 121.064 166.474Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.418 197.567C242.711 198.64 243.594 200.207 243.76 202.013C246.094 227.249 227.46 249.68 202.224 252.013C198.613 252.348 195.415 249.691 195.081 246.08C194.747 242.468 197.403 239.271 201.015 238.937C219.041 237.27 232.35 221.248 230.684 203.222C230.35 199.611 233.006 196.413 236.617 196.079C238.423 195.912 240.125 196.493 241.418 197.567Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.265 199.985C216.557 201.058 217.44 202.625 217.607 204.431C218.607 215.247 210.621 224.86 199.805 225.86C196.194 226.194 192.996 223.537 192.662 219.926C192.328 216.315 194.985 213.117 198.596 212.783C200.342 212.622 201.922 211.79 203.043 210.441C204.163 209.091 204.691 207.387 204.53 205.64C204.196 202.029 206.853 198.831 210.464 198.497C212.269 198.33 213.972 198.911 215.265 199.985Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.02 117.341H113.012L110.918 121.387H81.7852L82.7228 117.341H82.725C91.2996 88.4436 118.282 67.052 149.782 67.052C188.065 67.052 219.216 98.6513 219.214 136.92V141.122C219.214 162.548 208.569 182.433 190.737 194.315C177.671 203.025 171.066 215.381 164.685 227.33C155.619 244.301 146.242 261.85 119.575 261.85C97.9435 261.85 79.8853 244.26 79.8853 222.639V178.613H125.247C142.167 178.613 155.883 164.897 155.883 147.977C155.883 132.598 144.551 119.865 129.781 117.674C134.837 112.427 141.934 109.158 149.782 109.158C165.099 109.158 177.556 121.609 177.556 136.92V141.211C177.556 148.647 173.67 155.553 166.882 160.169C154.189 168.81 143.692 180.88 136.539 195.074C133.04 202.015 125.961 206.325 118.061 206.325H115.065C111.226 206.325 108.122 209.429 108.122 213.266C108.122 217.101 111.226 220.206 115.065 220.206H118.061C131.237 220.206 143.061 212.968 148.934 201.322C155.125 189.055 163.79 179.064 174.701 171.635C185.183 164.505 191.442 153.133 191.442 141.209V136.92C191.442 113.957 172.755 95.2768 149.782 95.2768C133.885 95.2768 120.04 104.222 113.02 117.341Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.779 38.1525V57.92C108.494 60.929 80.0725 85.8334 75.0336 117.558L74.5429 121.387H52.6528L53.3574 116.896C58.9158 74.6061 96.8267 41.2665 143.779 38.1525Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -2.64177,
    y1: 289.647,
    x2: 199.15,
    y2: 86.4104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white",
    transform: "translate(0.629883)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearing2);
export default __webpack_public_path__ + "static/media/Hearing 2.52f872e1.svg";
export { ForwardRef as ReactComponent };